module.exports = __webpack_public_path__ + "img/krbs_icon.c4a1ad8e.png";